import { z } from 'zod'
import { warehouseVersion } from './warehouse.ts'

const id = z.string().trim().min(1).max(200)
const nullableText = z.string().trim().max(10_000).nullable()
const contactFields = z
  .object({
    fullName: z.string().trim().min(1).max(300),
    role: z.string().trim().min(1).max(300),
    phone: z.string().trim().min(1).max(100).nullable(),
    email: z.email().max(320).nullable(),
    note: nullableText,
  })
  .strict()

export const supplierCreateSchema = z
  .object({
    name: z.string().trim().min(1).max(500),
    edrpou: z
      .string()
      .regex(/^\d{8,10}$/)
      .nullable(),
    city: z.string().trim().min(1),
    address: z.string().nullable(),
    contactName: z.string().nullable(),
    phone: z.string().nullable(),
    email: z.email().nullable(),
    terms: z.enum(['prepay', 'deferred_7', 'deferred_14', 'deferred_30']),
    note: z.string().nullable(),
    groups: z.array(z.string().trim().min(1).max(200)).max(50).default([]),
    contacts: z.array(contactFields).max(100).default([]),
  })
  .strict()
export const supplierUpdateSchema = z
  .object({ version: warehouseVersion, patch: supplierCreateSchema.partial() })
  .strict()
export const supplierArchiveSchema = z
  .object({ version: warehouseVersion, archived: z.boolean() })
  .strict()

const supplierReference = z.object({ version: warehouseVersion }).strict()
export const supplierAddContactSchema = supplierReference
  .extend({ contact: contactFields })
  .strict()
export const supplierUpdateContactSchema = supplierReference
  .extend({
    personId: id,
    patch: contactFields
      .partial()
      .strict()
      .refine((patch) => Object.keys(patch).length > 0),
  })
  .strict()
export const supplierContactReferenceSchema = supplierReference.extend({ personId: id }).strict()
export const supplierGroupCreateSchema = z.object({ name: id }).strict()
export const supplierGroupUpdateSchema = z.object({ version: warehouseVersion, name: id }).strict()
export const supplierGroupArchiveSchema = z
  .object({ version: warehouseVersion, archived: z.boolean() })
  .strict()

export type SupplierContactInput = z.infer<typeof contactFields>
